import { TRESPONSE_SPAREPART_LIST } from '@monorepo/types';
import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { FORM_MODIFIER } from '../../model/form.modifier';

export type TEditSparePartFormPayload = {
  id: number;
  updatedIsCritical: boolean;
  addedRemovedSpQty?: number;
  updatedThresholdOpt?: number;
  reason?: string;
  updatedCostOpt?: number;
  updatedRemarkOpt?: string;
};

export const EDIT_SPAREPART_FORM_MODEL = {
  createModel: (sparePart: TRESPONSE_SPAREPART_LIST['spareParts'][number]): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: sparePart.id,
          },
          metadata: {
            keyName: 'id',
            label: 'edit_sp.sparePartId',
            isHidden: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: sparePart.sparePartName,
          },
          metadata: {
            keyName: 'sparePartName',
            label: 'edit_sp.SpareParts',
            isReadonly: true,
            removeFromPayload: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: sparePart.sparePartNumber,
          },
          metadata: {
            keyName: 'sparePartNumber',
            label: 'edit_sp.Sparepartno.',
            isReadonly: true,
            removeFromPayload: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: sparePart.specification || '--',
          },
          metadata: {
            keyName: 'size',
            label: 'edit_sp.Specification/Size',
            isReadonly: true,
            removeFromPayload: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'number',
            value: sparePart.quantityInStock,
          },
          metadata: {
            isReadonly: true,
            removeFromPayload: true,
            keyName: 'updatedQuantity',
            label: 'edit_sp.Quantity/Stock',
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'number',
            value: 0,
            min: -1 * sparePart.quantityInStock,
          },
          metadata: {
            keyName: 'addedRemovedSpQty',
            label: 'edit_sp.Add/RemoveSP',
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: sparePart.brand,
          },
          metadata: {
            keyName: 'brand',
            label: 'edit_sp.Brand',
            isReadonly: true,
            removeFromPayload: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
          },
          metadata: {
            keyName: 'reason',
            label: 'edit_sp.QuantityUpdateReason:',
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'number',
            value: sparePart.thresholdOpt,
          },
          metadata: {
            keyName: 'updatedThresholdOpt',
            label: 'edit_sp.Threshold',
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'number',
            value: sparePart.costOpt,
          },
          metadata: {
            keyName: 'updatedCostOpt',
            label: 'edit_sp.Cost',
          },
        },
        {
          input: {
            type: 'TEXTAREA',
            value: sparePart.remarkOpt,
          },
          metadata: {
            keyName: 'updatedRemarkOpt',
            label: 'edit_sp.Remark',
          },
        },
        {
          input: {
            type: 'CHECKBOX',
            checked: sparePart.isCritical,
            disabled: false,
            indeterminate: false,
          },
          metadata: {
            keyName: 'updatedIsCritical',
            label: 'edit_sp.Critical',
            isRequired: true,
          },
        },
      ],
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
